import { useEffect, useRef } from 'react';
import { Box } from '../component-library';
import { calibrationConstants } from '../helpers/calibration-constants';
import { useParticipantTracks, useAttachTrack } from '../helpers/video/useParticipantTracks';
import styled from '@emotion/styled';

const StyledVideo = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  border-radius: ${calibrationConstants.VIDEO_BORDER_RADIUS}px;
`;

const Participant = ({ participant, parentVideoRef }) => {
  const { videoTrack, audioTrack } = useParticipantTracks(participant);
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  useAttachTrack(videoTrack, videoRef);
  useAttachTrack(audioTrack, audioRef);

  useEffect(() => {
    if (videoRef.current && parentVideoRef && parentVideoRef.current !== videoRef.current) {
      parentVideoRef.current = videoRef.current;
    }
  });

  return (
    <Box className='participant' position='relative' height='100%' width='100%'>
      <audio ref={audioRef} autoPlay />
      <StyledVideo ref={videoRef} autoPlay playsInline muted id={participant.sid} />
    </Box>
  );
};

export default Participant;
